// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_18_1-finance-program {
  /* Typography */
  --perxis-auto-finance-program-table-item-value-size-inner: var(
    --perxis-auto-finance-program-table-item-value-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-finance-program-table-item-value-font-weight-inner: var(
    --perxis-auto-finance-program-table-item-value-font-weight,
    700
  );
  --perxis-auto-finance-program-table-item-value-line-height-inner: var(
    --perxis-auto-finance-program-table-item-value-line-height,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-finance-program-title-font-family-inner: var(
    --perxis-auto-finance-program-title-font-family,
    var(--perxis-auto-root-typography-h4-font-family-inner)
  );
  --perxis-auto-finance-program-title-text-transform-inner: var(
    --perxis-auto-finance-program-title-text-transform,
    var(--perxis-auto-root-typography-h4-text-transform-inner)
  );
  --perxis-auto-finance-program-title-font-weight-inner: var(
    --perxis-auto-finance-program-title-font-weight,
    var(--perxis-auto-typography-h4-font-weight-inner)
  );
  --perxis-auto-finance-program-title-font-size-inner: var(
    --perxis-auto-finance-program-title-font-size,
    var(--perxis-auto-typography-h3-font-size-inner)
  );
  --perxis-auto-finance-program-title-line-height-inner: var(
    --perxis-auto-finance-program-title-line-height,
    var(--perxis-auto-typography-h4-line-height-inner)
  );
  --perxis-auto-finance-program-table-item-label-size-inner: var(
    --perxis-auto-finance-program-table-label-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-finance-program-table-item-label-line-height-inner: var(
    --perxis-auto-finance-program-table-label-line-height,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-finance-program-price-label-size-inner: var(
    --perxis-auto-finance-program-price-label-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-finance-program-price-label-line-height-inner: var(
    --perxis-auto-finance-program-price-label-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-finance-program-background-color-inner: var(
    --perxis-auto-finance-program-background-color,
    var(--perxis-auto-root-seventh-color-inner)
  );
  --perxis-auto-finance-program-hover-background-color-inner: var(
    --perxis-auto-finance-program-hover-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-finance-program-selected-background-color-inner: var(
    --perxis-auto-finance-program-selected-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-finance-program-border-color-inner: var(--perxis-auto-finance-program-border-color, transparent);
  --perxis-auto-finance-program-selected-border-color-inner: var(
    --perxis-auto-finance-program-selected-border-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-finance-program-hover-border-color-inner: var(
    --perxis-auto-finance-program-hover-border-color,
    var(--perxis-auto-finance-program-border-color-inner)
  );
  --perxis-auto-finance-program-color-inner: var(
    --perxis-auto-finance-program-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  --perxis-auto-finance-program-title-color-inner: var(
      --perxis-auto-finance-program-title-color,
      var(--perxis-auto-root-typography-color-darkest-inner)
    )
    --perxis-auto-finance-program-table-item-value-color-inner:
    var(
      --perxis-auto-finance-program-table-item-value-color,
      var(--perxis-auto-root-typography-color-darkest-light-inner)
    );
  --perxis-auto-finance-program-table-item-label-color-inner: var(
    --perxis-auto-finance-program-table-item-label-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  --perxis-auto-finance-program-price-label-color-inner: var(
    --perxis-auto-finance-program-price-label-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  --perxis-auto-finance-program-price-icon-color-inner: var(
    --perxis-auto-finance-program-price-icon-color,
    var(--perxis-auto-finance-program-selected-border-color-inner)
  );
  /* End Colors */
  /* Border */
  --perxis-auto-finance-program-border-radius-inner: var(--perxis-auto-finance-program-border-radius, 16px);
  --perxis-auto-finance-program-border-width-inner: var(--perxis-auto-finance-program-border-width, 2px);
  --perxis-auto-finance-program-hover-border-width-inner: var(
    --perxis-auto-finance-program-hover-border-width,
    var(--perxis-auto-finance-program-border-width-inner)
  );
  /* End Border */
  /* Height */
  --perxis-auto-finance-program-table-item-value-max-height-inner: var(
    --perxis-auto-finance-program-table-item-value-max-height,
    21px
  );
  --perxis-auto-finance-program-table-item-image-max-height-inner: var(
    --perxis-auto-finance-program-table-item-image-max-height,
    21px
  );
  /* Padding */
  --perxis-auto-finance-program-padding-inner: var(--perxis-auto-finance-program-padding, 18px 18px 24px 18px);
  --perxis-auto-finance-program-image-padding-top-inner: var(--perxis-auto-finance-program-image-padding-top, 20px);
  --perxis-auto-finance-program-table-item-padding-inner: var(--perxis-auto-finance-program-table-item-padding, 8px);
  /* End Padding */
  /* Box Shadow */
  --perxis-auto-finance-program-box-shadow-inner: var(--perxis-auto-finance-program-box-shadow, none);
  --perxis-auto-finance-program-hover-box-shadow-inner: var(
    --perxis-auto-finance-program-hover-box-shadow,
    0px 0px 20px rgba(12, 18, 28, 0.1)
  );
  /* End Box Shadow */
  /* Gap */
  --perxis-auto-divider-first-gap: 0;
  --perxis-auto-finance-program-table-item-value-container-gap-inner: var(
    --perxis-auto-finance-program-table-item-value-container-gap,
    8px
  );
  /* End Gap */
}
.perxis-auto-1_18_1-finance-program.ant-5_24_1-card {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: var(--perxis-auto-finance-program-padding-inner);
  margin: 0;
  min-height: 100%;
  font-family: var(--perxis-auto-finance-program-font-family-inner);
  font-size: var(--perxis-auto-finance-program-font-size-inner);
  line-height: var(--perxis-auto-finance-program-line-height-inner);
  font-weight: var(--perxis-auto-finance-program-font-weight-inner);
  text-transform: var(--perxis-auto-finance-program-text-transform-inner);
  letter-spacing: var(--perxis-auto-finance-program-letter-spacing-inner);
  background: var(--perxis-auto-finance-program-background-color-inner);
  color: var(--perxis-auto-finance-program-color-inner);
  border-radius: var(--perxis-auto-finance-program-border-radius-inner);
  border-width: var(--perxis-auto-finance-program-border-width-inner);
  border-color: var(--perxis-auto-finance-program-border-color-inner);
  border-style: solid;
  box-shadow: var(--perxis-auto-finance-program-box-shadow-inner);
}
.perxis-auto-1_18_1-finance-program.ant-5_24_1-card:hover {
  background: var(--perxis-auto-finance-program-hover-background-color-inner);
  box-shadow: var(--perxis-auto-finance-program-hover-box-shadow-inner);
  border-color: var(--perxis-auto-finance-program-hover-border-color-inner);
  border-width: var(--perxis-auto-finance-program-hover-border-width-inner);
}
.perxis-auto-1_18_1-finance-program.ant-5_24_1-card .ant-5_24_1-card-body {
  flex: 1;
  padding: 0;
}
.perxis-auto-1_18_1-finance-program .perxis-auto-1_18_1-finance-program-price-label {
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-finance-program-price-label-font-weight-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-finance-program-price-label-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-finance-program-price-label-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-finance-program-price-label-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-finance-program-price-label-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-finance-program-price-label-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-finance-program-price-label-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-finance-program-price-label-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-finance-program-price-label-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-finance-program-price-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-finance-program-price-label-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-finance-program-price-label-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-finance-program-price-label-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-finance-program-price-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-finance-program-price-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-finance-program-price-label-line-height-inner);
}
.perxis-auto-1_18_1-finance-program .perxis-auto-1_18_1-finance-program-price__check-icon {
  display: none;
}
.perxis-auto-1_18_1-finance-program--selected.ant-5_24_1-card {
  --perxis-auto-finance-program-border-color-inner: var(--perxis-auto-finance-program-selected-border-color-inner);
  --perxis-auto-finance-program-background-color: var(
    --perxis-auto-finance-program-selected-background-color-inner
  );
}
.perxis-auto-1_18_1-finance-program--selected .perxis-auto-1_18_1-finance-program-price__check-icon {
  --perxis-auto-typography-color-light: var(--perxis-auto-finance-program-price-icon-color-inner);
  display: block;
  --perxis-auto-typography-small-line-height-xxs: 0;
  --perxis-auto-typography-small-line-height-xs: 0;
  --perxis-auto-typography-small-line-height-sm: 0;
  --perxis-auto-typography-small-line-height-md: 0;
  --perxis-auto-typography-small-line-height-lg: 0;
  --perxis-auto-typography-small-line-height-xl: 0;
  --perxis-auto-typography-small-line-height-xxl: 0;
}
.perxis-auto-1_18_1-finance-program .perxis-auto-1_18_1-finance-program-image {
  position: absolute;
  top: 0;
  height: 100%;
  object-fit: contain;
}
.perxis-auto-1_18_1-finance-program .perxis-auto-1_18_1-finance-program-image-wrapper {
  position: relative;
}
.perxis-auto-1_18_1-finance-program .perxis-auto-1_18_1-finance-program-image-wrapper::before {
  content: "";
  display: block;
  width: 100%;
  height: 0;
  padding-top: var(--perxis-auto-finance-program-image-padding-top-inner);
}
.perxis-auto-1_18_1-finance-program .perxis-auto-1_18_1-finance-program-table__item {
  padding-top: var(--perxis-auto-finance-program-table-item-padding-inner);
  padding-bottom: var(--perxis-auto-finance-program-table-item-padding-inner);
}
.perxis-auto-1_18_1-finance-program .perxis-auto-1_18_1-finance-program-table__item-value {
  --perxis-auto-typography-small-font-weight: var(
    --perxis-auto-finance-program-table-item-value-font-weight-inner
  );
  --perxis-auto-typography-color-darkest: var(--perxis-auto-finance-program-table-item-value-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-finance-program-table-item-value-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-finance-program-table-item-value-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-finance-program-table-item-value-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-finance-program-table-item-value-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-finance-program-table-item-value-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-finance-program-table-item-value-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-finance-program-table-item-value-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-finance-program-table-item-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-finance-program-table-item-value-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-finance-program-table-item-value-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-finance-program-table-item-value-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-finance-program-table-item-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-finance-program-table-item-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-finance-program-table-item-value-line-height-inner);
}
.perxis-auto-1_18_1-finance-program .perxis-auto-1_18_1-finance-program-table__item-label {
  --perxis-auto-typography-small-font-weight: var(
    --perxis-auto-finance-program-table-item-label-font-weight-inner
  );
  --perxis-auto-typography-color-dark: var(--perxis-auto-finance-program-table-item-label-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-finance-program-table-item-label-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-finance-program-table-item-label-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-finance-program-table-item-label-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-finance-program-table-item-label-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-finance-program-table-item-label-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-finance-program-table-item-label-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-finance-program-table-item-label-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-finance-program-table-item-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-finance-program-table-item-label-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-finance-program-table-item-label-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-finance-program-table-item-label-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-finance-program-table-item-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-finance-program-table-item-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-finance-program-table-item-label-line-height-inner);
}
.perxis-auto-1_18_1-finance-program .perxis-auto-1_18_1-finance-program-table__item-icon {
  --perxis-auto-typography-small-line-height-xxs: 0;
  --perxis-auto-typography-small-line-height-xs: 0;
  --perxis-auto-typography-small-line-height-sm: 0;
  --perxis-auto-typography-small-line-height-md: 0;
  --perxis-auto-typography-small-line-height-lg: 0;
  --perxis-auto-typography-small-line-height-xl: 0;
  --perxis-auto-typography-small-line-height-xxl: 0;
}
.perxis-auto-1_18_1-finance-program .perxis-auto-1_18_1-finance-program-table__item-label-container {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.perxis-auto-1_18_1-finance-program .perxis-auto-1_18_1-finance-program-table__item-value-container {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: var(--perxis-auto-finance-program-table-item-value-container-gap-inner);
  max-height: var(--perxis-auto-finance-program-table-item-value-max-height-inner);
}
.perxis-auto-1_18_1-finance-program .perxis-auto-1_18_1-finance-program-table__item-image {
  max-height: var(--perxis-auto-finance-program-table-item-image-max-height-inner);
  max-width: 100%;
  flex: 0 1 auto;
}
.perxis-auto-1_18_1-finance-program .perxis-auto-1_18_1-finance-program-title__heading {
  --perxis-auto-typography-h4-font-family: var(--perxis-auto-finance-program-title-font-family-inner);
  --perxis-auto-typography-h4-text-transform: var(--perxis-auto-finance-program-title-text-transform-inner);
  --perxis-auto-typography-h4-font-weight: var(--perxis-auto-finance-program-title-font-weight-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-finance-program-title-color-inner);
  --perxis-auto-typography-h4-font-size-xxs: var(--perxis-auto-finance-program-title-font-size-inner);
  --perxis-auto-typography-h4-font-size-xs: var(--perxis-auto-finance-program-title-font-size-inner);
  --perxis-auto-typography-h4-font-size-sm: var(--perxis-auto-finance-program-title-font-size-inner);
  --perxis-auto-typography-h4-font-size-md: var(--perxis-auto-finance-program-title-font-size-inner);
  --perxis-auto-typography-h4-font-size-lg: var(--perxis-auto-finance-program-title-font-size-inner);
  --perxis-auto-typography-h4-font-size-xl: var(--perxis-auto-finance-program-title-font-size-inner);
  --perxis-auto-typography-h4-font-size-xxl: var(--perxis-auto-finance-program-title-font-size-inner);
  --perxis-auto-typography-h4-line-height-xxs: var(--perxis-auto-finance-program-title-line-height-inner);
  --perxis-auto-typography-h4-line-height-xs: var(--perxis-auto-finance-program-title-line-height-inner);
  --perxis-auto-typography-h4-line-height-sm: var(--perxis-auto-finance-program-title-line-height-inner);
  --perxis-auto-typography-h4-line-height-md: var(--perxis-auto-finance-program-title-line-height-inner);
  --perxis-auto-typography-h4-line-height-lg: var(--perxis-auto-finance-program-title-line-height-inner);
  --perxis-auto-typography-h4-line-height-xl: var(--perxis-auto-finance-program-title-line-height-inner);
  --perxis-auto-typography-h4-line-height-xxl: var(--perxis-auto-finance-program-title-line-height-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
